import { render, staticRenderFns } from "./petdrugType.vue?vue&type=template&id=65553e70&scoped=true"
import script from "./petdrugType.vue?vue&type=script&lang=js"
export * from "./petdrugType.vue?vue&type=script&lang=js"
import style0 from "./petdrugType.vue?vue&type=style&index=0&id=65553e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65553e70",
  null
  
)

export default component.exports